/*Tps-report*/
if(window.location.pathname.includes("reports/frv")){
    $.each($(".data-table"), function(){
        $(this).data("options", window.app_data.datatableOptions);
    });

    $("[name='frv_search']").on("keyup", function(){
        let val = $(this).val();
        $.each($(".data-table"), function(){
            $(this).DataTable().search(val).draw();
        });
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/frv.js